import React from 'react';
import { Fade } from '@material-ui/core';
import { isSuccessState } from 'globals/utils';
import reportLocales from 'globals/locales/report';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { useReportContext } from 'contexts/report/ReportContext';
import { observer } from 'mobx-react';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import { Caption, DataRow, Value, ValueSmall } from './Address.style-elements';

// Locales
const {
  address: { title, captions },
} = reportLocales;

const Address: React.FC = () => {
  const {
    report: {
      basicInfo: { status },
    },
  } = useReportContext();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withMargin={false}
      />
    );

  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsPaper title={title} data-test="address-component">
        <FsMinWidthScrollBox breakpointDown="sm">
          <DataRow>
            <Caption>{captions.currentAddress}</Caption>
            <ValueSmall>date moved: 12.03.2021</ValueSmall>
            <Value>52 Brook Street 1st Floor, Mayfair London W1K 5DS</Value>
          </DataRow>
          <DataRow isLast>
            <Caption>{captions.previousAddresses}</Caption>
            <Value>52 Brook Street 1st Floor, Mayfair London W1K 5DS</Value>
            <Value>52 Brook Street 1st Floor, Mayfair London W1K 5DS</Value>
            <Value>52 Brook Street 1st Floor, Mayfair London W1K 5DS</Value>
          </DataRow>
        </FsMinWidthScrollBox>
      </FsPaper>
    </Fade>
  );
};

export default observer(Address);
